import React from 'react'
import { axiosWithKey } from "~/axios"
import { getToken } from '~/redux/user/tokens'
import userStore from '~/redux/user/store'
import { login, fbLogin, googleLogin, signup, getCardInfo, refresh } from '~/redux/user/actions'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import { userLanguageSelector } from '~/tools/localization'
import { addUserProfile, trackEvent } from '~/tools/analytics/cleverTap'
import Spinner from '~/components/Spinner'
import popup from '../../popup'
import socialHelpers from '../socialHelpers'
import {PHONE_FROM_COUNTRY} from '../../countryConstants'
import jwtDecode from 'jwt-decode'
import './login.scss'
import { get, find } from 'lodash'
import Cookies from 'js-cookie'

export default class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      activeTab: this.props.activeTab ? this.props.activeTab : 'login',
      emailConsent: {},
      emailChecked: null,
      loading: true,
      metaDataMap: {}
    }

    this.toggleEmailCheck = this.toggleEmailCheck.bind(this)
    this.isOTPEnabled = get(window.settings, 'features.otp_value.otp_enabled');
    this.isEmailRequiredWithOTP = get(window.settings, 'features.otp_value.email_required');
  }

  getVal(key){
    return get(this.state.metaDataMap, key)
  }

  componentDidMount() {
    if (this.initializedSocialLogin) return
    this.initializedSocialLogin = true
    socialHelpers.initializeFacebookLogin()
    this.fetchEmailConsent()
    this.fetchPageData()
    const { pathname, search } = window.location
    const args = search.slice(1).split('&').map(v => v.split('=')).reduce((map, [key, value]) => map.set(key, decodeURIComponent(value)), new Map())
    if (pathname === '/sign-up' || args.get('signup') === 'true')  {
      this.setState({ activeTab: 'signup' })
      this.emailInput.value = args.get('email') || ''
    }
  }

  fetchPageData = () =>{
    const authNavObj = find(window.settings.navigation.user, function (o) {return (o.displayedPath === "Authentication Screen");})
    const { internalName } = window.settings;
    if(authNavObj){
      getToken(token => {
        var decodedToken = jwtDecode(token);
		    var tokenCountryCode = decodedToken.countryCode
        let baseUrl = ""
        if(window.settings.apiBaseUrl === "https://prod-api.viewlift.com") {
          baseUrl = "https://prod-api-cached-2.viewlift.com"
        } else {
          baseUrl = window.settings.apiBaseUrlCached || window.settings.apiBaseUrl
        }
        var contentApiHeaders = {
          Authorization: token,
          'x-api-key': window.settings.baseAPIKey,
        }
        return axiosWithKey({
          method: "GET",
          url: `${baseUrl}/content/pages?site=${internalName}&path=${authNavObj.url}&languageCode=${userLanguageSelector()}&includeContent=true&countryCode=${tokenCountryCode}`,
          headers: contentApiHeaders
        })
          .then(res => {
            const response = res.data.modules[0].metadataMap
            this.setState({metaDataMap: response, loading: false})
            if (get(window.settings, 'socialMedia.googlePlus.signin')) {
              socialHelpers.initializeGoogleLogin(this.googleButtonEl, this.googleLoginCallback.bind(this))
            }
          })
          .catch();
      });
    }
  }

  componentDidUpdate(){
    if(this.isOTPEnabled){
      this.checkForPhoneCode();
    }
    
  }

  checkForPhoneCode=()=>{
    return getCountryCode().then( countryCode => {
      if(this.phoneInputCode && !this.phoneInputCode.value)
        this.phoneInputCode.value="+"+PHONE_FROM_COUNTRY[`${countryCode}`]
    })
  }

  fetchEmailConsent() {
    let emailConsentUrl = `https://d2tipiv4cs5bo1.cloudfront.net/emailconsent/${window.settings.internalName}.json`;
    return axiosWithKey.get(emailConsentUrl).then( r => {
      let emailConsentConfig = r.data
      return getCountryCode().then( countryCode => {
        let config = emailConsentConfig[countryCode] || emailConsentConfig.default || {}
        this.setState({
          emailConsent: config, 
          emailChecked: config.checked,
          phoneCode: PHONE_FROM_COUNTRY[`${countryCode}`]
        }) 
      })
    }).catch( e => {
      return 
    })
  }
  
  renderEmailConsent() {
    const { emailConsent, emailChecked } = this.state
    if (!emailConsent.visible)
      return 
    
    return (
      <div className="email-consent">
        <input onChange={this.toggleEmailCheck} type="checkbox" checked={emailChecked}/>
        <div className="copy" dangerouslySetInnerHTML={{__html: emailConsent.copy}}></div>
      </div>
    )
  }

  toggleEmailCheck(e) {
    this.setState({
      emailChecked: e.target.checked
    })
  }

  shouldDisableLogin() {
    if (this.state.buttonProgress)
      return true

    return false
    // if (this.state.activeTab === 'login')
    //   return false
    // if (!this.state.emailConsent.visible)
    //   return false

    // return !this.state.emailChecked
  }

  populateEmailInput(){
    return( <div className="input-box">
    <input  
      type="email" 
      placeholder={this.getVal('emailInput')}
      ref={ i => { this.emailInput = i} }  
      onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } } 
      autoFocus 
      required       
    />
  </div>)
  }

  render() {
    if (this.state.loading)
      return (<div className="loading centered"><Spinner/></div>)

    const shouldDisableLogin = this.shouldDisableLogin()
    const isSVOD = window.settings.serviceType === 'SVOD'
    let isOTPEnabled = this.isOTPEnabled;
    let isEmailRequiredWithOTP=this.isEmailRequiredWithOTP;
    let showFacebook = get(window.settings, 'socialMedia.facebook.signin') || true

    return (
      <div className="auth-view centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <form
          className="login-view"
          onSubmit={ evt => {
            evt.preventDefault()
            this.state.activeTab === 'login' ? this.logIn() : this.signUp()
          } }>

          <div className="tab-buttons">
            <div
              className={ `login-tab-button tab-button ${ this.state.activeTab === 'login' ? 'active' : '' }` }
              onClick={ evt => { this.setState({ activeTab: 'login' }) } }
            > 
              <span className="site-border-color">{this.getVal('loginTab')}</span>
            </div>
            <div
              className={ `signup-tab-button tab-button ${ this.state.activeTab === 'signup' ? 'active' : '' }` }
              onClick={ evt => { this.props.hardwall ? popup.createSubscription() : this.setState({ activeTab: 'signup' }) } }
              > <span className="site-border-color">{isSVOD ? this.getVal('subscribeTab') : this.getVal('signUpTab')}</span> </div>
          </div>

          <div>

          {isOTPEnabled && <div className="phone-input-box">
             <input 
                placeholder="+91"
                ref={ i => { this.phoneInputCode = i} }  
                autoFocus  
                required
              />

              <input  
                type="number"
                placeholder={this.getVal('phoneInput') || "Please Enter Phone Number"}
                ref={ i => { this.phoneInputNumber = i} }  
                onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } } 
                autoFocus 
                required         
              />
            </div>}

            {isOTPEnabled  && this.state.activeTab === 'login' &&
            <span onClick={()=>{
              popup.loginEmailPassword(this.state.metaDataMap);
            }} className="site-border-color login-email-password">
              {this.getVal('loginEmailPassword') || "Login with Email and Password"}           
           </span>}

            {(!isOTPEnabled || (isOTPEnabled && isEmailRequiredWithOTP && this.state.activeTab === 'signup'))
              && this.populateEmailInput()
            }

            {!isOTPEnabled && <div className={ `input-box collapsible ${this.state.activeTab === 'login' ? 'collapsed': ''}` }>
              { this.state.activeTab !== 'login' && (
                <input 
                  placeholder={this.getVal('nameInput')}
                  ref={ i => { this.nameInput = i} } 
                  onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } } 
                  required
                />
              ) }
            </div>}
            
            {!isOTPEnabled && <div className="input-box">
              <input
                placeholder={this.getVal('passwordInput')}
                ref={ i => { this.passwordInput = i} }
                type="password"
                onFocus={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } }
                onKeyUp={ e => { if (this.state.activeTab === 'signup') this.checkPwdValid(e) } }
                onKeyPress={ e => {
                  if (e.key === 'Enter') { this.state.activeTab === 'login' ? this.logIn() : this.signUp() }
                } }
                required/>
            </div>}      
            
            { this.state.activeTab === 'signup' &&
              this.renderEmailConsent() 
            }
          </div>
          <div className={ `error-box collapsible ${ this.state.error ? '' : 'collapsed' }` }>
            { this.state.error || '' }
          </div>
          <div>
            <input
              type="submit"
              className={`login-button button fat cta ${ shouldDisableLogin ? 'disabled' : '' }`}
              value={
                this.state.activeTab === 'login' ?
                  (this.state.buttonProgress ? this.getVal('loginProcessingCta') : this.getVal('loginCta')) :
                  (this.state.buttonProgress ? (isSVOD? this.getVal('subscribeProcessingCta') : this.getVal('signUpProcessingCta') ) : this.getVal('signUpCta'))
              } />
              {!isOTPEnabled &&  <div
                className="forgot-password-button fat"
                onClick={ _ => { popup.forgotPassword(this.props.hardwall, this.state.metaDataMap) } }>
                  {this.getVal('forgotPasswordCtaText')}
              </div>}
          </div>
          
        </form>

        <div className="or">
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="text">{this.getVal('orSeparator')}</div>
        </div>
        <div className="social-logins">
          <div className="social-buttons">
          { showFacebook && 
            <button 
              disabled={shouldDisableLogin} 
              className="facebook-color-background button fat" 
              onClick={ e => this.facebookLogin(e) }
            >
              { this.state.activeTab === 'login' ? this.getVal('facebookLoginCta') : this.getVal('facebookSignUpCta') }
            </button>
            }
              <br />
            {get(window.settings, 'socialMedia.googlePlus.signin') && 
              <button 
                disabled={shouldDisableLogin} 
                className="google-color-background button fat" 
                ref={ el => this.googleButtonEl = el }
              >
                { this.state.activeTab === 'login' ? this.getVal('googleLoginCta') : this.getVal('googleSignUpCta') }
              </button> 
            }
            {/* { get(window.settings, 'serviceType') === 'TVE' && 
            <button 
              style={{'background':'#6d6b6b'}}
              disabled={shouldDisableLogin} 
              className="button fat" 
              onClick={evt => {popup.providerList() } }
            >
                Choose Tv Provider
            </button>
            } */}
          </div>
        </div>

        { this.state.activeTab === 'signup' && window.settings.features.legal_verbiage &&
            <div className="ageCheck">
              { this.state.ageCheckError && !this.state.ageIsChecked && 
                <div className="ageCheckError">{this.state.ageCheckError}</div>
              }
              <input 
                name="ageCheck"
                type="checkbox"  
                checked={this.state.ageIsChecked} 
                id="ageCheck" 
                onClick={() => this.setState({
                  ageIsChecked:!this.state.ageIsChecked, 
                  ageCheckError:null
                })}
              />
              <label htmlFor="ageCheck">{window.settings.features.legal_verbiage_copy}</label>
            </div>
          }
      </div>
    )
  }

  socialLogins() {
    return (
      <div>
      </div>
    )
  }

  facebookLogin(e) {
    const element = document.getElementById('ageCheck')
    if(element){
      const ageCheck = element.checked
      if (!ageCheck){
        this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
        return
      }
    }


    window.FB.login( res => {
      var accessToken = res && res.authResponse && res.authResponse.accessToken
      if (!accessToken)
        return this.alert(this.getVal('facebookError'))
      //Keeping Track for SignUp Event if SignUp From Facebook;
      if(this.state.activeTab !== 'login')
        Cookies.set('isUserSignUp', true)
      this.dispatchSocialLogin(fbLogin({
        facebookToken: accessToken,
        emailConsent: (this.state.activeTab === 'signup' && this.state.emailConsent.visible) ? this.state.emailChecked : undefined
      }), 'Facebook')
    }, { scope: 'email,public_profile' })
  }

  googleLoginCallback(error, googleUser) {
    if (error)
      return this.alert(this.getVal('googleError'))
    var accessToken = googleUser.getAuthResponse().id_token;
    this.dispatchSocialLogin(googleLogin({
      googleToken: accessToken,
      emailConsent: (this.state.activeTab === 'signup' && this.state.emailConsent.visible) ? this.state.emailChecked : undefined
    }), 'Google')
  }

  logIn() {
    if (this.state.buttonProgress)
      return
      
    this.setState({buttonProgress: true })

    var creds = {
      email: this.emailInput && this.emailInput.value,
      password: this.passwordInput &&  this.passwordInput.value
    }

    this.dispatchLogin(login(creds), 'Native')
  }


  dispatchSocialLogin(act, loginType) {
    if(this.props.onInitiate){ this.props.onInitiate('login') }
    userStore
      .dispatch(act)
      .then( _ => {
        var userInfo = userStore.getState().user || {}
        trackEvent('Login', {platform: 'Web', registrationType: loginType})
        userStore
          .dispatch(getCardInfo(userInfo))
          .then(res => {
            if (this.props.onAuthenticate) {
              this.props.onAuthenticate(true)
              return false
            } else if (!_.value.isSubscribed && window.settings.serviceType === "SVOD") {
              if(this.props.args === "FREE" || this.props.args === "AVOD")  {
                window.location.reload();
                return false;
              }    
              window.location.href = "/viewplans";
              return false;
            } else if(window.settings.serviceType === "AVOD") {
              window.location.reload()
              return false;
            }
          });
        this.setState({ buttonProgress: false })
        popup.hide()     
      })
      .then(res => {
        userStore
        .dispatch(refresh())
      })
      .catch( error => {
        var errorCode = ""
        this.setState({ buttonProgress: false })
        if(error.response && error.response.data) {
          errorCode = error.response.data.code
        }
        var message = this.getVal(errorCode) || this.getVal('defaultError') ;
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
  }


  async dispatchLogin(act, loginType) {
    if(this.isOTPEnabled){
      let user={};
      user["requestType"]="send";
      user["phoneNumber"]=this.phoneInputCode.value+this.phoneInputNumber.value;
      user["screenName"]="signin"

      var signupParams = {
        site: window.settings.internalName
      }
      
      await axiosWithKey({
        method: 'POST',
        url: `${window.settings.apiBaseUrl}/identity/signin`,
        params: signupParams,
        data: user,
        headers: {
          'x-api-key': window.settings.baseAPIKey
        }
      }).then( res => {
        popup.verifyOTPScreen(user, this.state.metaDataMap);
      }).catch(error=>{
        this.setState({ buttonProgress: false })
        var message = this.getVal((((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
        message= error && error.response && error.response.data && error.response.data.error;
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
    }else{

      if(this.props.onInitiate){ this.props.onInitiate('login') }
      userStore
      .dispatch(act)
      .then( _ => {
        var userInfo = userStore.getState().user || {}
        userInfo && addUserProfile("Site", {
          Name: userInfo.name,
          Email: userInfo.email,
          Identity: userInfo.userId,
          "User Status": userInfo.isSubscribed
            ? "Subscribed"
            : "Registered and Never Subscribed"
        });
        trackEvent('Login', {platform: 'Web', registrationType: loginType})
        userStore
          .dispatch(getCardInfo(userInfo))
          .then(res => {
            if (this.props.onAuthenticate) {
              this.props.onAuthenticate(true)
              return false
            } else if (!_.value.isSubscribed && window.settings.serviceType === "SVOD") {
              if(this.props.args === "FREE" || this.props.args === "AVOD")  {
                window.location.reload();
                return false;
              }    
              window.location.href = "/viewplans";
              return false;
            } else if(window.settings.serviceType === "AVOD") {
              window.location.reload()
              return false;
            }
          });
        this.setState({ buttonProgress: false })
        popup.hide()     
      })
      .then(res => {
        userStore
        .dispatch(refresh())
      })
      .catch( error => {
        var errorCode = ""
        this.setState({ buttonProgress: false })
        if(error.response && error.response.data) {
          errorCode = error.response.data.code
        }
        var message = this.getVal(errorCode) || this.getVal('defaultError') ;
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
    }
  }

  async signUp() {
    const element = document.getElementById('ageCheck')
    
    if(element){
      const ageCheck = element.checked
      if (!ageCheck){
        this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
        return
      }
    }

    if (this.state.buttonProgress)
      return

    this.setState({buttonProgress: true, error: '' })

    var user = {
      name: this.nameInput && this.nameInput.value,
      email: this.emailInput && this.emailInput.value,
      password: this.passwordInput && this.passwordInput.value,
      emailConsent: this.state.emailConsent.visible ? this.state.emailChecked : undefined,
    }

    if(this.isOTPEnabled){
      var userPhoneObj={};
      userPhoneObj["requestType"]="send";
      userPhoneObj["phoneNumber"]=this.phoneInputCode.value+this.phoneInputNumber.value;
      userPhoneObj["emailConsent"]=user.emailConsent;
      if(this.emailInput){
        userPhoneObj["email"]=user.email;
      }

      var signupParams = {
        site: window.settings.internalName
      }

      await axiosWithKey({
        method: 'POST',
        url: `${window.settings.apiBaseUrl}/identity/signup`,
        params: signupParams,
        data: userPhoneObj,
        headers: {
          'x-api-key': window.settings.baseAPIKey
        }
      }).then( res => {
        userPhoneObj["screenName"]="signup"
        popup.verifyOTPScreen(userPhoneObj, this.state.metaDataMap);
      }).catch(error=>{
        this.setState({ buttonProgress: false })
        var message =
        this.getVal( (((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })

    }else{

      if(this.props.onInitiate){ this.props.onInitiate('signup') }
        userStore
          .dispatch(signup(user))
          .then( _ => {
            var userInfo = this.props.user
            userInfo && addUserProfile('Site', {
              'Name': userInfo.name,
              'Email': userInfo.email,
              'Identity': userInfo.userId,
              'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
            })
            trackEvent('Signed Up', {registrationType: 'Native',platform:'Web'})
            //The User has successfully Signed Up and we need to save this to open personalization screen when succesfully sign up
            Cookies.set('isUserSignUp', true)

            if(this.props.onAuthenticate){ 
              this.props.onAuthenticate(true) 
              return false
            } else if(!_.value.isSubscribed && window.settings.serviceType === "SVOD"){
              if(this.props.args === "FREE" || this.props.args === "AVOD") {
                window.location.reload()
                return false;
              }
              window.location.href="/viewplans";
              return false;
            } else if(window.settings.serviceType === "AVOD") {
                window.location.reload()
                return false;
            }
            this.setState({ buttonProgress: false })
            popup.hide()
          })
          .then(res => {
            userStore
            .dispatch(refresh())
          })
          .catch(error => {
            this.setState({ buttonProgress: false })
            var message =
              this.getVal((((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
            this.alert(message)
            if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
          })
    }
  }

  checkPwdValid(e){
    if(!this.passwordInput)
      return
    
    let password = this.passwordInput.value;
    const atPassword = e.currentTarget.type.indexOf('password') !== -1
    const errorTextBox = document.getElementsByClassName('error-box')
    errorTextBox[0].classList.remove('collapsed')
    if ((password.length < 5 || password.length > 50) && atPassword ){
      errorTextBox[0].textContent = this.getVal('passwordLengthError')
      return false;
    }
    errorTextBox[0].textContent= ''
    errorTextBox[0].classList.add('collapsed')
    if(!atPassword) {
      errorTextBox[0].classList.add('collapsed')
    }
  }

  alert(txt) {
    this.setState({ error: txt })
  }
}